import type { CompanyInfo } from '@/types';

export const company: CompanyInfo = {
  name: 'Helmflex Solutions',
  shortName: 'Helmflex',
  tagline: 'Planiranje i vođenje poslovnih projekata.',
  description:
    'Pomažemo malim i srednjim preduzećima da pripreme plan, usklade učesnike i sprovedu poslovne projekte.',
  email: 'office@helmflex.rs',
  phone: '+381 11 555 01 20',
  phoneHref: '+381115550120',
  address: 'Bulevar poslovnih ideja 24, Beograd',
  workingHours: 'Ponedeljak – petak, 08:00 – 17:00',
  socials: {
    facebook: { label: 'Facebook', url: 'https://facebook.com' },
    instagram: { label: 'Instagram', url: 'https://instagram.com' },
    linkedin: { label: 'LinkedIn', url: 'https://linkedin.com' },
    x: { label: 'X / Twitter', url: 'https://x.com' }
  },
  mapEmbedUrl:
    'https://www.google.com/maps?q=Belgrade%2C%20Serbia&z=13&output=embed'
};

export const navigation = [
  { label: 'Početna', to: '/' },
  { label: 'Usluge', to: '/usluge' },
  { label: 'O nama', to: '/o-nama' },
  { label: 'Kontakt', to: '/kontakt' }
] as const;
